import React from "react";
import styles from "./GlobalRetail.module.scss";

const GlobalRetail: React.FC = () => {
  return (
    <div id="Domestic Retail" className={styles.GlobalRetail}>
      <div className="container">
        <div className="subSection">
          <div className="row">
            <div className="col-12">
              <p
                className={`cardHeading caps text-center ${styles.institutionalTitle} mb-1`}
              >
                <strong>International Retail</strong>
              </p>
              <div
                className={`d-flex flex-column justify-content-center align-items-center`}
              >
                <div className={styles.institutionalPara}>
                  <p className="para text-center">
                    With a strong presence via <strong>740+ centres</strong>{" "}
                    across <strong>200+ cities</strong> globally, Aptech
                    delivers world-class training in{" "}
                    <strong>
                      IT, networking, English language training, animation
                    </strong>
                    , and <strong>multimedia</strong>. Our global training
                    centres located in countries like{" "}
                    <strong>
                      Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi Arabia,
                      Nigeria
                    </strong>{" "}
                    and many more, provide learners with internationally
                    recognized certifications, preparing them for global career
                    growth opportunities.
                  </p>
                  <p className="para text-center">
                    <strong>
                      Through all three businesses -{" "}
                      <a href="/our-businesses/domestic-retail">
                        Domestic Retail
                      </a>
                      ,{" "}
                      <a href="/our-businesses/institutional-business">
                        Institutional Business
                      </a>{" "}
                      and{" "}
                      <a href="/our-businesses/international-retail">
                        International Retail
                      </a>
                      , Aptech continues to empower individuals and
                      organisations, contributing significantly to employability
                      and global skill development.
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalRetail;
